export default __webpack_public_path__ + "static/media/circleX.d7ace0f6.png";